import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Box,Collapse,IconButton,Paper,Table,TableBody,TableCell,LinearProgress,
        TableContainer,TableHead,TableRow,} from '@material-ui/core';
//import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
//import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import { useHistory } from "react-router-dom";

import CreateIcon from '@material-ui/icons/Create';
import {llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';
import {findNumber} from "../funciones/FindNumber";
import NumberFormat from 'react-number-format';
const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    //maxHeight: 550,
    maxHeight: window.innerHeight-170,
    minHeight: 280,
    minWidth:'100%',
  },
  container2: {
    maxHeight: 550,
    //maxHeight: window.innerHeight-170,
    //minHeight: 280,
  },
  tableRow: {
    "&$selected, &$selected:hover": {
      backgroundColor: "#F58634"
    }
  },
  tableCell: {
    "$selected &": {
      color: "white"
    }
  },
  hover: {},
  selected: {}
});

export default function TablaRenta({setOrdenSeleccion,  fSeleccionadas, buscar, setModalEdit, estatus, datos, setDatos, cargaEdit, Tipo, folio}) {
  const classes = useStyles();
  let history = useHistory();
  const source = axios.CancelToken.source();    
  const idusu= localStorage.getItem('UsuId');
  const [selectedID, setSelectedID] = useState([]);
  //const [open, setOpen] = React.useState(false);     
  const [espera,setEspera]=useState(false);
  const [colTotal,setColTotal]=useState([]);
  

  let nvlSNPermiso ='5'      
  React.useEffect(()=>{ 
    //console.log(folio);    
            
    //const fInicio=moment(fSeleccionadas.inicio).format("YYYY-MM-DD")
    //const fFinal=moment(fSeleccionadas.final).format("YYYY-MM-DD")
    const llenaListTabla = () => { 
      setOrdenSeleccion([])     
      setSelectedID([])    
      const data = qs.stringify({    
        Usuario:idusu,    
        Tipo:Tipo,
        Proveedor:0,//fInicio+'T00:00:00' ,
        IsVigente:0,//fFinal+'T23:59:59',    
        Status: estatus !== 0 ? parseInt(estatus): 0,
        Cadena:folio,
        idDispositivo:'89y7gttvjhj98h'
      });
      const url = "/renta/filtro";
      function respuestaListTabla(aux) {
        if (aux[0].Id !== -1 && aux[0].Id !== "-1") 
        {// console.log(aux);  
          let auxImporte=0, auxImpuesto=0, auxSuma=0
          aux.forEach(element => {
            auxSuma = element.Importe + element.Impuesto + auxSuma
            auxImporte = element.Importe + auxImporte
            auxImpuesto = element.Impuesto + auxImpuesto
          }); 
          setColTotal({auxImporte:auxImporte, auxImpuesto:auxImpuesto, auxSuma:auxSuma})                                                               
          setDatos(aux)
         // setListCCTV(aux)
        }
        else
        { setDatos([])
          //setListCCTV([])
        }           
      }

      llamaApiCargaToken(data, url,respuestaListTabla,ErrorGeneral,setEspera,history,source);
    }; 
   
    llenaListTabla();      
    return ()=> {
      source.cancel();
    }                

  },[buscar]); 

  const seleccionado=( auxOrden)=>{
    setSelectedID(auxOrden)    
    setOrdenSeleccion(auxOrden)  
  }

  function editarFall(auxFalla) {
    //console.log(datos);
    //console.log(auxFalla);
    setOrdenSeleccion(auxFalla)
    setModalEdit(true)
  }
   
  function tipoEstado(estado,idSelecc)
  { let auxEtiqueta=''
    let auxColor=''
    if (estado===0) 
    {
      auxEtiqueta='Registrado'
      auxColor='#F46239'
    }
    else
    {
      if (estado ===1) 
      {
        auxEtiqueta='Activo'
        auxColor='#049b4f'
      }
      else
      {
        if (estado === 2) 
        {
          auxEtiqueta='Cancelado'
          auxColor='red'
        } 
      }
    }
    let renglon=<div></div>
    selectedID.Id === idSelecc?
    renglon=<TableCell align="center" style={{ color:'white',fontWeight:700 ,width:120+'px'}} padding={'none'}>
              {auxEtiqueta}
            </TableCell>:
    renglon=<TableCell align="center" style={{ color:auxColor,fontWeight:700,width:120+'px'}} padding={'none'}>{auxEtiqueta}</TableCell>
    return renglon
  }

  const celda = (alinear, estilo, contenido) => {
    return (
      <TableCell
        align={alinear} className={classes.tableCell}
        padding={"none"} style={estilo} 
      >
        {contenido}
      </TableCell>
    );
  };

function Row(props) {
  const { row } = props;
  
  return (
    <React.Fragment>
      <TableRow onClick={ () => { seleccionado(row, ); } }
        className={classes.tableRow} selected={ selectedID?.Id === row.Id}
        classes={{ hover: classes.hover, selected: classes.selected }}        
      >
        {/* <TableCell align="center" padding={'none'} style={{ width:30+'px'}} >
          <IconButton color="primary"  aria-label="expand row" size="small" onClick={() => verMas(row.Id)}>
            { open && ordenSelecc=== row.Id ?( selectedID === row.Id?<KeyboardArrowUpIcon style={{color:'white'}} />:
                                                  <KeyboardArrowUpIcon  />) : 
              selectedID === row.Id ? <KeyboardArrowDownIcon style={{color:'white'}}  />:<KeyboardArrowDownIcon  />}            
          </IconButton>
        </TableCell> */}
        {celda("center",{width:30+'px'},
           findNumber('|35|') ?<IconButton   aria-label="add circle" size="small"  
            component="span" onClick={() => editarFall(row)} >
            {selectedID?.Id === row.Id 
              ?   <CreateIcon style={{color:'white'}} />
              :   <CreateIcon color="primary"/>
            }
          </IconButton>:null                                                                                                                                                                  
        )}         
        {celda("center",{fontWeight:700, width:30+'px', paddingRight:"5px"},row.Poliza)}      
        {celda("center",{width:60+'px', paddingRight:"5px"},moment.utc(row.FIni).local(true).format("DD/MM/YYYY"))}                           
        {celda("center",{width:60+'px',paddingRight:"5px"},moment.utc(row.FFin).local(true).format("DD/MM/YYYY"))}  
        {celda("center",{width:30+'px',fontSize:"12px",},row.TpNom)}      
        {celda("left",{ width:40+'px',paddingLeft:"4px",  },row.StNom)} 
        {celda("right", {width:90+'px', paddingRight:"10px", fontSize:"12px",}, 
          <NumberFormat value={row.Importe} displayType={'text'}  thousandSeparator={true} /> 
          ) }      
        {celda("right", {width:90+'px', fontSize:"12px", paddingRight:"10px"},
          <NumberFormat value={row.Impuesto} displayType={'text'}  thousandSeparator={true} /> 
          )}     
        {celda("right", {width:90+'px', paddingRight:"10px", fontSize:"12px",},<NumberFormat value={row.Importe+row.Impuesto} displayType={'text'}  thousandSeparator={true} /> )}
      </TableRow>
      <TableRow>        
      </TableRow>
    </React.Fragment>
    );
  }

  function tablaCompleta(auxlista){
    //console.log("entrando sin preguntar");
    return(
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>            
              <TableCell align="center" padding='none'></TableCell>                                    
              <TableCell align="center" padding='none'>Folio</TableCell>                    
              <TableCell align="center" padding='none'>Fecha Inicio</TableCell>
              <TableCell align="center" padding='none'>Fecha Final</TableCell>
              <TableCell align="center" padding='none'>Tipo</TableCell>     
              <TableCell align="center" padding='none'>Estatus</TableCell>     
              <TableCell align="right" padding='none' style={{paddingRight:"10px", color:"#278508"}}  > <>Importe <br/>
                {colTotal.length !== 0 ? <NumberFormat value={colTotal.auxImporte} displayType={'text'}  thousandSeparator={true} />:""}</></TableCell>
              <TableCell align="right" padding='none' style={{paddingRight:"10px", color:"#278508"}} > <>Impuesto<br/>{colTotal.length !== 0 ? 
                <NumberFormat value={colTotal.auxImpuesto} displayType={'text'}  thousandSeparator={true} />:""}</></TableCell>    
              <TableCell align="right" padding='none' color="secondary"  style={{paddingRight:"10px", color:"#278508"}} > <>Total<br/>{colTotal.length !== 0 ? 
              <NumberFormat value={colTotal.auxSuma} displayType={'text'}  thousandSeparator={true} />:""}</></TableCell>     
            </TableRow>
          </TableHead>
          <TableBody>
            {auxlista.length!=0 ? (auxlista.map((row) => (
                <Row key={row.Id} row={row} />
            ))):null}
          </TableBody>
        </Table>
      </TableContainer>
   )
  }

  const tablaSinDatos=()=>{
   return(<TableContainer className={classes.container2}>
    <Table stickyHeader aria-label="sticky table">
      <TableHead>
        <TableRow>            
          <TableCell align="center"> </TableCell>            
          <TableCell align="left">Fecha</TableCell>
          <TableCell align="left">Estatus</TableCell>                                           
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow className={classes.tableRow} >          
          <TableCell  className={classes.tableCell} align="center">Dia</TableCell>          
          <TableCell  className={classes.tableCell} align="left">Sin</TableCell>             
          <TableCell  className={classes.tableCell} align="left">Registros</TableCell>                      
        </TableRow>
      </TableBody>
    </Table>
    </TableContainer>
    ) 
  }

  const tablaSinResultados=()=>{
    return(<TableContainer className={classes.container2}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>            
            <TableCell align="center"> </TableCell>            
            <TableCell align="left">Fecha</TableCell>
            <TableCell align="left">Estatus</TableCell>                    
          </TableRow>
        </TableHead>
        <TableBody>
        <TableRow className={classes.tableRow} >          
          <TableCell  className={classes.tableCell} align="center"></TableCell>          
          <TableCell  className={classes.tableCell} align="left">Sin</TableCell>             
          <TableCell  className={classes.tableCell} align="left">coincidencias</TableCell>                  
         </TableRow>
       </TableBody>
      </Table>
    </TableContainer>
    ) 
   }

  function filtro()
  {        console.log(folio);
  
    let info=[] , metodos=null
    if (folio.length!==0) 
    { let auxCadena=folio.trim();
      info=datos.filter((dat)=>dat.Id.toString().search(auxCadena) !== -1)                 
    }    
    
    if (info.length>0) 
    { metodos= tablaCompleta(info)
    } 
    else 
    { metodos=tablaSinResultados()
    }
    return metodos ;
  }

  //const contenido2= folio.length!==0&& folio!==''  ? filtro() :tablaCompleta(datos) 
  const contenido = datos.length!== 0 ?tablaCompleta(datos) :tablaSinDatos()
  const tabla = espera|| cargaEdit ?  (<Box><LinearProgress/> </Box>) :( contenido )
 
  return (
    <Paper className={classes.root}>
      {tabla}
    </Paper>
  );
}
